import { Box, Button, Typography, useTheme } from '@mui/material';
import { staticContent } from 'components/constants/Constants';
import { Link } from 'react-router-dom';
import { tss } from 'tss-react/mui';

interface CarrouselSlideProps {
  image: string;
  title: string;
  description: string;
  productLink: string;
}

export const CarrouselSlide = ({
  image,
  title,
  description,
  productLink
}: CarrouselSlideProps) => {
  const theme = useTheme();
  const { classes } = useStyles();
  return (
    <Box sx={{ height: '100%', width: '100%' }} key={title}>
      <img src={`${staticContent}/${image}`} alt={title} />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          opacity: '.15'
        }}
      ></Box>
      <Box className={classes.headerText} key={title}>
        <Typography
          variant="h1"
          sx={{
            whiteSpace: {
              xs: 'normal',
              md: 'nowrap'
            },
            mb: 2,
            minWidth: 'min-content',
            color: ({ palette }) => palette.secondary.light
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h3"
          sx={{
            mb: 4,
            color: theme.palette.secondary.light
          }}
        >
          {description}
        </Typography>
        <Button component={Link} to={productLink} variant="contained">
          Discover
        </Button>
      </Box>
    </Box>
  );
};

const useStyles = tss.create(({ theme }) => ({
  headerText: {
    position: 'absolute',
    right: '15%',
    top: '40%',
    width: '500px',
    [theme.breakpoints.down('lg')]: {
      right: '18%'
    },

    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
      left: 40
    }
  }
}));
